import Navbar from "./navbar";
import Hero from "./hero";
import VideoBackground from "./video-background";

export default function HeroWithNavbarBackground() {
  return (
    <div className="relative w-screen h-screen overflow-hidden text-white">
      <VideoBackground />
      <Navbar />
      <Hero />
    </div>
  );
}
